import React from 'react'

import {useDialogContext} from '../Dialog/DialogContext'
import {Row} from 'jsxstyle'
import {FaXmark} from 'react-icons/fa6'

interface ConfirmDialogHeaderProps {
  title?: string
  closeButton?: boolean
}

const ConfirmDialogHeader: React.FC<ConfirmDialogHeaderProps> = ({title, closeButton = false}) => {
  const {close} = useDialogContext()

  return (
    <Row
      alignItems="center"
      justifyContent="space-between"
      boxSizing="border-box"
      gap="20px"
      minWidth="0"
      minHeight="28px"
      padding="20px 28px 4px 28px"
    >
      <Row alignItems="center" fontSize="15px" lineHeight="20px" gap="8px" color="#333333" minWidth="0" fontWeight={600} flexShrink={0}>
        {title}
      </Row>
      {closeButton && (
        <Row
          component="button"
          border="none"
          background="none"
          alignItems="center"
          justifyContent="center"
          padding="6px"
          cursor="pointer"
          color="#AAAAAA"
          hoverColor="#666666"
          flexShrink={0}
          props={{
            onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
              e.stopPropagation()
              close()
            },
          }}
        >
          <FaXmark size={16} />
        </Row>
      )}
    </Row>
  )
}

export default ConfirmDialogHeader
